import React from "react";
import { connect } from "react-redux";
import styled from 'styled-components';
import { setFocusVod } from "../action";
import { VOD_FILE } from "../constants";
import { getFocusVodItem, getMediaList } from "../function";
import { isCheckPermission } from "../../localuser";
import { PERMISSION } from "../../participants";

const VodStyled = styled.div`
    display: flex;
    gap: 2px;
    flex-direction: column;
    overflow: auto;

    .name {
        background: #d5d5d5;
        border-bottom: 1px solid #d5d5d5;
        padding: 8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 4px;
        word-break: keep-all;
        color: #000;
        text-align: center;   

        &.item_${props => props.focusUuid} {
            background-color: #ababab;
        }

        .text {    
            max-width: 115px;
            max-height: 30px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-break: keep-all;
        }
        svg {margin: 0; cursor: pointer;}
    }
`;

function VodList({
    dispatch, mediaList, focusUuid, permission
}) {
    return (
        <VodStyled focusUuid={focusUuid}>
            { mediaList.map(([uuid, item]) => {
                const handlerSelectMedia = () => {
                    if (!permission) return;
                    dispatch(setFocusVod(item.uuid));
                };

                // const handlerDeleteMedia = () => {
                //     dispatch(delVodList(item.uuid));
                // }
                
                return (
                    <React.Fragment key={item.uuid}>
                        <div className={`name item_${item.uuid} nonSelect`} onClick={handlerSelectMedia}>
                            {/* <MdDelete size={20} onClick={handlerDeleteMedia} /> */}
                            <span className="text">
                                { item.type === VOD_FILE ? item.name : item.url }
                            </span>
                        </div>
                        {/* {  item.type === VOD_FILE && !item.channel_id && <span>영상 변환중</span>} */}
                    </React.Fragment>
                )
            })}
        </VodStyled>
    )
}

function _mapStateToProps(state) {
    const list =  getMediaList(state);
    const focusUuid = state['features/base/vod'].vod_shared_video_uuid;
    const permission = isCheckPermission(state, PERMISSION.SHARE);
    
    return {
        mediaList: [...list],
        focusUuid,
        permission
    }
}

export default connect(_mapStateToProps)(VodList);
